/**
 * Gradient hairline under the header row; spans every column in the CSS grid.
 * Matches BaseSystemDrawerLayout / ProductDetailsDrawerLayout.
 */
export function BrandHeaderGradientRule() {
  return (
    <div
      className="from-secondary to-primary bg-greyscale-background col-span-full h-px w-full shrink-0 bg-gradient-to-r"
      style={{ gridColumn: "1 / -1" }}
      role="presentation"
    />
  );
}
